export enum IntegrationAuthTypes {
	CREDENTIALS = 'CREDENTIALS',
	OAUTH1 = 'OAUTH1',
	OAUTH2 = 'OAUTH2',
}
